/* unplugin-vue-components disabled */import { render } from "./detail copy 2.vue?vue&type=template&id=0f6544b5&scoped=true"
import script from "./detail copy 2.vue?vue&type=script&lang=js"
export * from "./detail copy 2.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_detail.scss?vue&type=style&index=0&id=0f6544b5&scoped=true&lang=scss&external"
import "./detail copy 2.vue?vue&type=style&index=1&id=0f6544b5&lang=css"
import "./detail copy 2.vue?vue&type=style&index=2&id=0f6544b5&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6544b5"]])

export default __exports__